import {
  IconBookmark,
  IconBuildings,
  IconCctvLine,
  IconEthernetLine,
  IconInfoCircle,
  IconPencil,
  IconShare,
  IconTools,
  IconVideoLine,
} from '@assets/images/icon';
import { cameraEdge, camreaServer } from '@assets/images/main/camera';

export default {
  a: [
    { text: '제품 설명', icon: IconInfoCircle },
    { text: '처리 구조', icon: IconEthernetLine },
    { text: '영상 수집 방식', icon: IconVideoLine },
    { text: '지원 카메라 수', icon: IconCctvLine },
    { text: '설치 방식', icon: IconTools },
    { text: '활용 공간', icon: IconBuildings },
    { text: '추천 환경', icon: IconBookmark },
    { text: '특장점', icon: IconPencil },
    { text: '외부 연동', icon: IconShare },
  ],

  b: [
    { text: '단일 장비에 AI 분석 + ORBRO OS 내장' },
    { text: 'Edge 단말 단독 운영 (ORBRO OS 포함)' },
    { text: 'RTSP / ONVIF 등 네트워크 영상 수집' },
    { text: '최대 2대' },
    { text: '전원 + 카메라 연결만으로 간편 설치' },
    { text: '출입구, 좁은 실내 공간, 소규모 사업장' },
    { text: '서버 없이 빠른 설치와 기본 기능이 필요한 현장' },
    { text: '장비 1대로 설치/운영 가능, 저비용 구조' },
    { text: 'API 일부 제공 (기본 연동 가능)' },
  ],

  c: [
    { text: '서버 기반의 고성능 AI 영상 분석 시스템' },
    { text: 'AI Server + ORBRO Server 연동' },
    { text: 'RTSP / ONVIF 등 네트워크 영상 수집' },
    { text: '최대 6대 이상 (서버 확장 가능)' },
    { text: '서버실/관제실 중심, 네트워크 기반 구성' },
    { text: '대형 병원, 물류센터, 공공기관 등 통합 관제' },
    { text: '중·대규모 시설에서 다채널 영상 분석 필요 시' },
    { text: 'SOP, Heatmap, Zone 등 ORBRO OS 고급 기능과 완전 연동' },
    { text: 'API 제공 (실시간 이벤트/위치/상황 연동)' },
  ],

  spec: [
    {},

    {
      image: cameraEdge,
      link: '/camera/edge',
      title: 'ORBRO Edge AI',
      desc: '',
    },

    {
      image: camreaServer,
      link: '/camera/server',
      title: 'ORBRO AI Server',
      desc: '',
    },
  ],
};
